export type ClerkImageFit = 'crop' | 'scale-down'

export interface ClerkImageOptions {
    width: number
    height: number
    fit?: ClerkImageFit
    quality?: number
}

const CLERK_IMAGE_HOSTS = new Set(['img.clerk.com', 'images.clerk.dev'])

export function isClerkImageUrl(url: string | null | undefined): boolean {
    if (!url) return false

    try {
        const parsed = new URL(url)
        return CLERK_IMAGE_HOSTS.has(parsed.hostname)
    } catch {
        return false
    }
}

export function optimizeClerkImageUrl(
    url: string | null | undefined,
    {
        width,
        height,
        fit = 'crop',
        quality = 85
    }: ClerkImageOptions
): string | undefined {
    if (url === null || url === undefined) return undefined
    if (url === '') return ''

    if (!isClerkImageUrl(url)) return undefined

    const parsed = new URL(url)
    parsed.searchParams.set('width', String(width))
    parsed.searchParams.set('height', String(height))
    parsed.searchParams.set('fit', fit)
    parsed.searchParams.set('quality', String(quality))
    return parsed.toString()
}
